<template>
  <div class="welcome wbg">
    <div class="top" v-if='$common.AUTH("payee:lists")'>
      <a-row class="row" :gutter="20">
        <a-col class="flex" :span="6">
          <label style="padding-left: 28px;">被告：</label>
          <a-input placeholder='请输入被告姓名' v-model='form.debtor'> </a-input>
        </a-col>
        <a-col class="flex" :span="6">
          <label>证件号码/代码：</label>
          <a-input placeholder='请输入证件号码/代码' v-model='form.chinaid'> </a-input>
        </a-col>
        <a-col class="flex" :span="6">
          <label>原告：</label>
          <a-select v-model="form.accuser_id" placeholder="请选择原告" class="select" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='6' @change="ckAcc" :filter-option="$common.filterOption">
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id" :title="item.title">{{
              item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col class="flex" :span="6">
          <label>业务部门：</label>
          <a-select v-model="form.team_id" placeholder="请选择" class="select">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for="item in teamList" :key="item.team.title" :value="item.team_id">{{ item.team.title
            }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row class="row" :gutter="20">
        <a-col :span="6" class="flex">
          <label style="width: 90px;text-align: right;">录入日期：</label>
          <timePick @PickTime="PickTime" ref="timePicker"></timePick>
        </a-col>
        <a-col :span="8" class="flex">
          <a-button icon="search" @click='form.page = 1; query()' style="margin-right:20px;height:32px;">查询</a-button>
          <a-button @click='reset' style="margin-right:20px;height:32px;">重置</a-button>
          <!-- <a-button v-if="$common.AUTH('1-2-3')" icon="upload" @click="download()" type="primary" ghost>导出</a-button> -->
          <router-link v-if="$common.AUTH('credit:payee/add')" :to='{ "name": "AmountDetails", params: { id: 0 } }'>
            <a-button icon='plus' style="height:32px;">新增</a-button>
          </router-link>
        </a-col>
      </a-row>
    </div>
    <div class="tableList" v-if='$common.AUTH("payee:lists")'>
      <div class="table">
        <table>
          <thead class="thead">
            <td width='70'>序号</td>
            <td width='70'>被告</td>
            <td width='160'>证件号码/代码</td>
            <td width='65'>所属案件</td>
            <td width='100'>当前进度</td>
            <td width='270'>原告</td>
            <td width='100'>已履行金额</td>
            <td width='100'>未履行金额</td>
            <td width='100'>已确认债权</td>
            <td width='100'>录入日期</td>
          </thead>
          <tbody>
            <tr v-for='(i, index) in list' :key='i.id'>
              <td>{{ 10 * (form.page - 1) + index + 1 }}</td>
              <td><span class="curpoter" @click='dbclick(i)'>
                  <Normap :tit='i.realname'>{{ i.realname }}</Normap>
                </span></td>
              <td>
                <p>
                  <Normap :tit='i.chinaid'>{{ i.chinaid }}</Normap>
                </p>
              </td>
              <td>
                <p v-for='(j, index) in i.cause' :key="index">案件{{ j.sort }}</p>
              </td>
              <td>
                <p v-for='(j, index) in i.cause' :key="index">
                  <span v-if="j.step && j.step.length">{{ j.step[0].title }}</span>
                  <span v-else>/</span>
                </p>

              </td>
              <td>
                <p v-for='(j, index) in i.cause' :key="index">
                  <Normap :tit='j.accuser.title'>{{ j.accuser.title }}</Normap>
                </p>
              </td>
              <td>
                <p v-for='(j, index) in i.cause' :key="index">
                  <a-popover>
                    <template slot="content">
                      <div class="contbox">
                        <p v-for='(k, inde) in px(j.payeeGroupList)' :key="inde">{{ k.type_title }}:{{ k.fee | showYuan
                        }}
                        </p>
                      </div>
                    </template>
                    <span> {{ j.payeeSum | showYuan }}</span>
                  </a-popover>
                </p>
              </td>
              <td>
                <p v-for='(j, index) in i.cause' :key="index">
                  <a-popover>
                    <template slot="content">
                      <div class="contbox">
                        <p v-for='(k, inde) in px(noGroupList(j.payeeGroupList, rPropo(j.credit)))' :key="inde">
                          {{ k.type_title }}:{{ k.fee | showYuan }}</p>
                      </div>
                    </template>
                    <span> {{ (j.creditSum - j.payeeSum) | showYuan }}</span>
                  </a-popover>
                </p>
              </td>
              <!-- <td>
              <p v-for='j in i.cause'>
                <a-popover>
                  <template slot="content">
                    <div class="contbox">
                      <p v-for='(k,inde) in px(j.loanGroupList)'>{{k.type_title}}:{{k.fee | showYuan}}</p>
                    </div>
                  </template>
                  <span> {{j.loanSum | showYuan}}</span>
                </a-popover>
              </p>
            </td> -->
              <td>
                <p v-for='(j, index) in i.cause' :key="index">
                  <a-popover>
                    <template slot="content">
                      <div class="contbox">
                        <p v-for='(k, inde) in npx(j.credit)' :key="inde">{{ k.type_title }}:{{ k.fee | showYuan }}</p>
                      </div>
                    </template>
                    <span> {{ j.creditSum | showYuan }}</span>
                  </a-popover>
                </p>
              </td>
              <td>
                <p v-for='(j, index) in i.cause' :key="index" v-if='j.payees.length > 0'>
                  <Normap :tit='j.payees[0].create_time | yearFormat'>{{ j.payees[0].create_time | yearFormat }}
                  </Normap>
                </p>
              </td>
              <!--  <td>
              <router-link :to="{ name: 'AmountSee', params: { id: i.id } }" target='_blank' v-if="$common.AUTH('B3')">查看</router-link>
             <a-button type='link' style="padding:0;">查看</a-button> 
            </td>-->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pages">
        <a-pagination v-model="form.page" show-quick-jumper :total="total" show-less-items :pageSize='10'
          @change='turnpage' :show-total="total => `被告：${total}  案件数：${cause_count}`" />
      </div>
    </div>
    <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
  </div>
</template>
<script>
import { Tacitly } from '@/assets/js/Tacitly'
import { getCollection } from '@/server/collection'
import { getAccuserAll } from '@/server/api'
import Propo from './step.json'
const Proposition = [...Propo, {
  "tit": "银行结清款",
  "type": "11"
}]
export default {
  data() {
    return {
      accuserList: [],
      list: [],        //项目列表
      time: null,
      total: 0,
      cause_count: 0,
      form: {
        accuser_id: [],
        team_id: "",
        limit: 10,
        page: 1,
        chinaid: '',
        stime: '',
        etime: '',
        debtor: '',
      },
    }
  },
  computed: {
    teamList() {
      return this.form.accuser_id.length > 1 || this.form.accuser_id.length == 0 ? [] : this.accuserList.find(ele => {
        return ele.id === this.form.accuser_id[0]
      }).team
    }
  },
  mounted() {
    let _this = this
    document.onkeydown = function (e) {
      // console.log(e)
      if (e.keyCode == 13) {
        _this.query()
      }
    }
  },
  created() {
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
    this.query()
  },
  methods: {
    Allfree(Arr) {
      let i = 0;
      let newNum = Arr.map(e => {
        i += e.fee / 100 * 1
      })
      return i
    },
    rPropo(Arr) {
      let newArr = []
      Object.keys(Proposition).map(item => {
        let isInclude = Arr.some(it => {
          return it.type == item
        })
        if (isInclude == false) {
          newArr.push({
            type_title: Proposition[item],
            type: item * 1,
            fee: 0
          })
        } else {
          newArr.push(Arr.filter(ele => { return ele.type == item })[0])
        }
      })
      return newArr
    },
    noGroupList(payeeGroupList, Allcredit) {    //未履行
      let Arr = []
      payeeGroupList.map(ele => {
        Allcredit.map(element => {
          if (ele.type == element.type) {
            Arr.push({
              fee: element.fee - ele.fee,
              type: ele.type,
              type_title: ele.type_title
            })
          }
        })
      })
      return Arr
    },
    notP(has, all) {
      return (all - has)
    },
    turnpage(val) {
      this.form.page = val;
      this.query()
    },
    reset() {
      this.form.limit = 10
      this.form.page = 1
      this.form.debtor = ''
      this.form.chinaid = ''
      this.form.accuser_id = []
      this.form.team_id = ''
      this.form.status = ''
      this.form.stime = ''
      this.form.etime = ''
      this.$refs.timePicker.clearTime()
      this.query()
    },
    query() {
      const form = JSON.parse(JSON.stringify(this.form))
      form.accuser_id = form.accuser_id.toString()
      getCollection(form).then(e => {
        this.list = e.list
        this.cause_count = e.cause_count
        this.total = e.count
      })
    },
    ckAcc(val) {
      if (val.length > 1 || val.length == 0) {
        this.form.team_id = ''
      }
    },
    dbclick(record) {
      if (this.$common.AUTH('payee:info:lists')) {
        let routeUrl = this.$router.resolve({ "name": "AmountSee", params: { "id": record.id } });
        window.open(routeUrl.href, '_blank');
      }
      else {
        this.$message.error({ content: '暂无权限', key: 'updatable' });
      }
    },
    PickTime(e) {
      if ("stime" in e) {
        this.form.stime = e.stime
      }
      else {
        this.form.etime = e.etime
      }
    },
    px(Arr, s) {
      let newArr = []
      if (Arr) {
        Proposition.map(ele => {
          let s = Arr.find(s => { return s.type == ele.type })
          if (ele.type != 6) {
            newArr.push({
              type_title: ele.tit,
              type: ele.type,
              fee: s ? s.fee : 0
            })
          }
        })
        return newArr
      }
    },
    npx(Arr) {
      let newArr = []
      if (Arr) {
        Proposition.map(ele => {
          let s = Arr.find(s => { return s.type == ele.type })
          newArr.push({
            type_title: ele.tit,
            type: ele.type,
            fee: s ? s.fee : 0
          })
        })
        return newArr
      }
    },
    download() {
      let http = Tacitly.Base_Port
      this.$modal.confirm({
        content: '确认导出这个文件？',
        onOk: () => {
          window.open(http + 'export/hktj?accuser_id=' + this.form.accuser_id + '&debtor=' + (this.form.debtor ? this.form.debtor : '') + '&stime=' + (this.form.stime ? this.form.stime : '') + '&etime=' + (this.form.etime ? this.form.etime : '') + '&team_id=' + this.form.team_id)
        }
      })
    }
  }
}
</script>
<style lang="less">
.bigerSta {
  .ant-statistic-content-value-int {
    font-size: 1.125rem;
  }
}
</style>
<style lang="less" scoped>
.contbox {
  display: flex;
  width: 510px;
  box-sizing: border-box;
  background: #ffffff;
  flex-wrap: wrap;

  p {
    font-size: 0.875rem;
    margin-bottom: 0;
    line-height: 30px;
    margin-right: 20px;
  }
}

.welcome {
  position: relative;

  .top {
    @import url('@/assets/css/search.less');
  }

  .tableList {
    margin-top: 20px;
    width: 100%;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          p {
            padding: 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }

  .static {
    padding: 20px 0;
    background: #f3f6fb;
    margin: 20px 30px;

    .ul {
      display: flex;
      flex-wrap: wrap;

      &:nth-child(1) {
        padding-bottom: 14px;
        border-bottom: 1px solid #dbdcde;
        margin-bottom: 20px;

        .li {
          margin-bottom: 16px;
        }
      }

      .li {
        width: 20%;
        padding-left: 60px;
        font-size: 0.875rem;
        color: #66707c;
        line-height: 24px;

        b {
          font-size: 1.25rem;
          color: #0e2949;
        }
      }
    }
  }

  .list {
    background: #fff;
    margin-top: 10px;
    overflow: hidden;
  }

  .pages {
    text-align: right;
  }
}
</style>